import { useState } from "react";
import { cn } from "@/lib/utils";

interface CountryFlagIconProps {
  countryCode: string;
  size?: "xs" | "sm" | "md" | "lg";
  className?: string;
}

const sizeClasses = {
  xs: "w-4 h-4",
  sm: "w-5 h-5",
  md: "w-7 h-7",
  lg: "w-9 h-9",
};

// flagcdn uses lowercase ISO 3166-1 alpha-2 codes
function getFlagUrl(code: string, width = 80): string {
  return `https://flagcdn.com/w${width}/${code.toLowerCase()}.png`;
}

export function CountryFlagIcon({ countryCode, size = "md", className }: CountryFlagIconProps) {
  const [error, setError] = useState(false);
  const code = countryCode?.toUpperCase() || "";

  if (error || !code) {
    return (
      <span
        className={cn(
          sizeClasses[size],
          "inline-flex items-center justify-center text-center leading-none",
          className
        )}
      >
        🌍
      </span>
    );
  }

  return (
    <span
      className={cn(
        sizeClasses[size],
        "inline-block rounded-full overflow-hidden flex-shrink-0 ring-1 ring-border/30",
        className
      )}
    >
      <img
        src={getFlagUrl(code)}
        alt={code}
        className="w-full h-full object-cover"
        loading="lazy"
        onError={() => setError(true)}
      />
    </span>
  );
}
